// Auto-generated from classicalMusicFiles/*.txt
// Re-generate: python generate_classical_player.py --react

const classicalAlbums = [
  {
    title: "Bach - Classical Music for Brain Power",
    url: "https://www.dropbox.com/scl/fi/t0l64k4hcnahhf74rzzqt/Bach-Classical-Music-for-Brain-Power-VmImA0YKsJg.m4a?rlkey=rqd9uwugvsv4zenusvv50inou&st=9317qw41&raw=1",
    tracks: [
      [0, "Brandenburg Concerto No. 5 in D Major, BWV 1050: III. Allegro", "Orchestra da Camera del Conservatorio di Mantova, Paolo Ghidoni"],
      [336, "Orchestral Suite No. 2 in B Minor, BWV 1067: IV. Bourr�es I & II", "Budapest Scoring Symphonic Orchestra, Peter Illenyi"],
      [456, "Brandenburg Concerto No. 3 in G Major, BWV 1048: III. Allegro (Live)", "Orchestra da Camera Fiorentina, Giuseppe Lanzetta"],
      [743, "I. Allemande French Suite No. 5 in G Major, BWV 816:", "Vadim Chaimovich"],
      [934, "II. Courante", "Vadim Chaimovich"],
      [1044, "IV. Gavotte", "Vadim Chaimovich"],
      [1121, "VII. Gigue", "Vadim Chaimovich"],
      [1343, "Brandenburg Concerto No. 6 in B-Flat Major, BWV 1051: III. Allegro", "Orchestra da Camera del Conservatorio di Mantova, Giuseppe Santoro"],
      [1701, "Brandenburg Concerto No. 4 in G Major, BWV 1049: III. Presto", "Orchestra da Camera del Conservatorio di Mantova, Paolo Ghidoni"],
      [1984, "Orchestral Suite No. 1 in C Major, BWV 1066: VI. Bourr�e I, II", "Budapest Scoring Symphonic Orchestra, Peter Illenyi"],
      [2164, "Brandenburg Concerto No. 3 in G Major, BWV 1048: I. � (Live)", "Orchestra da Camera Fiorentina, Giuseppe Lanzetta"],
      [2524, "Cello Suite No. 3 in C Major, BWV 1009: V. Bourr�e I - Bourr�e II", "Massimiliano Martinelli"],
      [2761, "VI. Gigue", "Massimiliano Martinelli"],
      [2951, "Cello Suite No. 1 in G Major, BWV 1007: I. Pr�lude", "Massimiliano Martinelli"],
      [3128, "Orchestral Suite No. 1 in C Major, BWV 1066: I. Ouverture", "Budapest Scoring Symphonic Orchestra, Peter Illenyi"],
      [3535, "Brandenburg Concerto No. 5 in D Major, BWV 1050: I. Allegro", "Orchestra da Camera del Conservatorio di Mantova, Paolo Ghidoni"],
      [4131, "Orchestral Suite No. 1 in C Major, BWV 1066: IV. Forlane", "Budapest Scoring Symphonic Orchestra, Peter Illenyi"],
      [4244, "Brandenburg Concerto No. 6 in B-Flat Major, BWV 1051: II. Adagio, ma non tanto", "Orchestra da Camera del Conservatorio di Mantova, Giuseppe Santoro"],
      [4543, "I. Italian Concerto, BWV 971:", "Benedetta Iardella"],
      [4795, "III. Presto", "Benedetta Iardella"],
      [5007, "French Suite No. 3 in B Minor, BWV 814: V. Menuet", "Vadim Chaimovich"],
      [5147, "French Suite No. 5 in G Major, BWV 816: VI. Loure", "Vadim Chaimovich"],
      [5291, "Brandenburg concerto No. 5 in D Major, BWV 1050: II. Affettuoso (Live)", "Orchestra da Camera Fiorentina, Giuseppe Lanzetta"],
      [5628, "Brandenburg Concerto No. 4 in G Major, BWV 1049: I. Allegro", "Orchestra da Camera del Conservatorio di Mantova, Paolo Ghidoni"],
      [6044, "Harpsichord Concerto No. 1 in D Minor, BWV 1052: I. Allegro", "Budapest Scoring Symphonic Orchestra, Peter Illenyi"],
      [6485, "Concerto for Oboe d'amore, Strings and Continuo in A Major, BWV 1055: I. Allegro moderato", "L'Ensemble Instrumental de France, Maurice Bourgue"],
      [6775, "French Suite No. 5 in G Major, BWV 816: V. Bourr�e", ""],
      [6865, "VI. Gigue", "Vadim Chaimovich"],
      [6993, "IV. Anglaise", "Vadim Chaimovich"],
      [7093, "Cello Suite No. 3 in C Major, BWV 1009: II. Allemande", "Massimiliano Martinelli"],
      [7337, "Cello Suite No. 6 in D Major, BWV 1012: I. Pr�lude", "Massimiliano Martinelli"],
      [7694, "Cello Suite No. 1 in G Major, BWV 1007: III. Courante", "Massimiliano Martinelli"],
      [7845, "Concerto for Oboe d'amore, Strings and Continuo in A Major, BWV 1055: III. Allegro ma non tanto", "L'Ensemble Instrumental de France, Maurice Bourgue"],
      [8139, "Brandenburg Concerto No. 2 in F Major, BWV 1047: I. Allegro", "Orchestra da Camera del Conservatorio di Mantova, Paolo Ghidoni"],
    ],
  },
  {
    title: "Baroque Music for Studying & Brain Power",
    url: "https://www.dropbox.com/scl/fi/t23ow7o43hoh3tg5ml3yr/Baroque-Music-for-Studying-Brain-Power-BjnnUCmNREI.m4a?rlkey=h6gs53g5cl18xawdr1ru7tqkn&st=526bzs4c&raw=1",
    tracks: [
      [0, "Antonio Vivaldi: Symphony in C Major, RV 112: III. Presto", ""],
      [43, "Antonio Vivaldi: Concerto for Strings & Continuo in C Major, RV 113: I. Allegro", ""],
      [162, "Antonio Vivaldi: Concerto for Strings & Continuo in C Major, RV 113: III. Allegro", ""],
      [350, "Antonio Vivaldi: Concerto for Strings in D Major, RV 121: III. Allegro", ""],
      [471, "Antonio Vivaldi: Symphony in E Major, RV 132: I. Allegro", ""],
      [724, "Antonio Vivaldi: Symphony in E Major, RV 132: III. Allegro", ""],
      [879, "Antonio Vivaldi: Strings Concerto in B-Flat Minor, RV 164: I. Allegro", ""],
      [998, "Antonio Vivaldi: Symphony in G Major, RV 149: I. Allegro molto", ""],
      [1110, "Antonio Vivaldi: Symphony in G Major, RV 149: III. Allegro", ""],
      [1239, "Antonio Vivaldi: Symphony in C Major, RV 112: I. Allegro", ""],
      [1358, "Antonio Vivaldi: Strings Concerto in G Minor, RV 152: II. Andante molto", ""],
      [1468, "Antonio Vivaldi: Strings Concerto in B-Flat Minor, RV 164: III. Allegro", ""],
      [1550, "Arcangelo Corelli: Concerto Grosso No. 9 in F Major, Op. 6: I. Preludio", ""],
      [1677, "Arcangelo Corelli: Concerto Grosso No. 9 in F Major, Op. 6: II. Allemanda", ""],
      [1852, "Arcangelo Corelli: Concerto Grosso No. 9 in F Major, Op. 6: III. Corrente", ""],
      [1966, "Arcangelo Corelli: Concerto Grosso No. 9 in F Major, Op. 6: IV. Gavotta. Allegro", ""],
      [2031, "Arcangelo Corelli: Concerto Grosso No. 9 in F Major, Op. 6: VI. Minuetto", ""],
      [2150, "Georg Philip Telemann: Viola Concerto in G Major, TWV 51:G9: II. Allegro", ""],
      [2340, "Georg Philip Telemann: Viola Concerto in G Major, TWV 51:G9: IV. Presto", ""],
      [2526, "Arcangelo Corelli: Concerto Grosso No. 1 in D Major, Op. 6: V. Allegro", ""],
      [2664, "Arcangelo Corelli: Concerto Grosso No. 10 in C Major, Op. 6: II. Allemanda", ""],
      [2853, "Arcangelo Corelli: Concerto Grosso No. 10 in C Major, Op. 6: IV. Corrente", ""],
      [3009, "Arcangelo Corelli: Concerto Grosso No. 10 in C Major, Op. 6: V. Allegro", ""],
      [3189, "Arcangelo Corelli: Concerto Grosso No. 10 in C Major, Op. 6: VI. Minuetto", ""],
      [3297, "Johann Sebastian Bach: Cello Suite No. 1 in G Major, BWV 1007: IV. Sarabande", ""],
      [3457, "Johann Sebastian Bach: Brandenburg Concerto No. 3 in G Major, BWV 1048: I. Allegro", ""],
      [3815, "Johann Sebastian Bach: Brandenburg Concerto No. 5 in D Major, BWV 1050: I. Allegro", ""],
      [4456, "Johann Sebastian Bach: Brandenburg Concerto No. 5 in C Major, BWV 1050: III. Allegro", ""],
    ],
  },
  {
    title: "Rachmaninoff - Piano Concerto #2 in C Minor, Op. 18 - HD",
    url: "https://www.dropbox.com/scl/fi/ngkgyf1u8g63prwarshuz/Rachmaninoff-Piano-Concerto-2-in-C-Minor-Op.-18-HD-yJpJ8REjvqo.m4a?rlkey=mdmob7d3fzu2uh110eo5mbcr5&st=6g136pn1&raw=1",
    tracks: [
      [0, "Mvtm1", ""],
      [674, "Mvtm2", ""],
      [1340, "Mvtm3", ""],
    ],
  },
  {
    title: "Tchaikovsky classical music for studying",
    url: "https://www.dropbox.com/scl/fi/0yacla0kj0m5dbbdaefrl/Tchaikovsky-classical-music-for-studying-1-A9RAKeUr8.mp3?rlkey=8rmqhp4rj5rx4npsylx7yodj5&st=stgke6j9&raw=1",
    tracks: [
      [479, "beautiful", ""],
      [840, "beautiful", ""],
    ],
  },
  {
    title: "Bible - 1 John",
    url: "https://www.dropbox.com/scl/fi/q88ri7fq5uiy6kiv3pfsh/1john_no_indent.mp3?rlkey=twx6inklr8f0z7xfg11i8c5do&raw=1",
    tracks: [],
  },
  {
    title: "Bible - Galatians",
    url: "https://www.dropbox.com/scl/fi/c9mg65ynx8ciomg9exz5f/galatians_no_indent.mp3?rlkey=3bw5gsmyhrcxb4ne1wdlzsg67&raw=1",
    tracks: [],
  },
  {
    title: "Bible - Hebrews",
    url: "https://www.dropbox.com/scl/fi/vp0g5k2mhjx7c5mp0mc8p/hebrews_no_indent.mp3?rlkey=m490gkfrt86yw329do08gwmud&st=54drbvus&raw=1",
    tracks: [],
  },
  {
    title: "Bible - Romans",
    url: "https://www.dropbox.com/scl/fi/i4pqzqrgcc33r4s648spf/romans_no_indent.mp3?rlkey=jq1qjitzzcfsborvy2042lja7&st=ibb8lwyz&raw=1",
    tracks: [],
  },
];

export default classicalAlbums;
